import type { ButtonHTMLAttributes, ReactNode, Ref } from 'react';
import { clsx } from 'clsx';
import { Icon } from './icons';

export type ButtonVariant = 'prominent' | 'tinted' | 'plain' | 'neutral' | 'destructive';
export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant; size?: 'small' | 'regular' | 'large'; loading?: boolean; icon?: string; fullWidth?: boolean;
  ref?: Ref<HTMLButtonElement>;
}
export function Button({ variant = 'prominent', size = 'regular', loading, icon, fullWidth, className, children, disabled, type = 'button', ...props }: ButtonProps) {
  return <button {...props} type={type} disabled={disabled || loading} aria-busy={loading || undefined}
    className={clsx('hylo-button', `hylo-button--${variant}`, `hylo-button--${size}`, fullWidth && 'hylo-button--full', className)}>
    {loading ? <span className="hylo-spinner" aria-hidden="true" /> : icon && <Icon name={icon} />}{children}
  </button>;
}

export interface IconButtonProps extends Omit<ButtonProps, 'children' | 'aria-label'> { name: string; label: string; selected?: boolean }
export function IconButton({ name, label, selected, className, variant = 'plain', ...props }: IconButtonProps) {
  return <Button {...props} variant={variant} className={clsx('hylo-icon-button', selected && 'is-selected', className)}
    aria-label={label} title={props.title ?? label} aria-pressed={selected} icon={name} />;
}

export interface ToolbarButtonProps extends Omit<IconButtonProps, 'name'> { name?: string; children?: ReactNode }
export function ToolbarButton({ name, label, selected, className, children, ...props }: ToolbarButtonProps) {
  return <Button {...props} variant={props.variant ?? 'plain'} className={clsx('hylo-toolbar-button', selected && 'is-selected', className)}
    aria-label={label} title={props.title ?? label} aria-pressed={selected} icon={name}>{children}</Button>;
}
